<template>
  <div class="home page-container" v-if="!isMobile">
    <!--banner-->
    <div class="banner" @mouseenter="bannerSwiperMouseenter" @mouseleave="bannerSwiperMouseleave">
      <swiper :options="bannerSwiper" key="banner_swiper" ref="bannerSwiperRef">
        <!-- slides -->
        <swiper-slide
          v-for="(item,index) in filterBillboard"
          data-index="index"
          :key="'banner_swiper_'+index">
          <div v-if="item.URL">
            <a style="cursor: pointer" @click="onClickBillboard(item.URL, item.MIMEType)">
              <img class='swiImg' :src='item.Image'/>
            </a>
          </div>
          <div v-else><img class='swiImg' :src='item.Image'/></div>
        </swiper-slide>
        <div class="swiper-pagination home-banner-pagination" slot="pagination"></div>
      </swiper>
    </div>

    <!-- <div class="icon-sub-header">
      <div class="icon-box">
        <div class="icon-square">
          <div class="icon-cont">
            <img src="../assets/img/freeDelivery.svg" style="height: 56px; width: 56px"/> -->
            <!-- <font-awesome-icon icon="truck" :style="{ color: 'black', fontSize: '50px',  }"/> -->
          <!-- </div>
          <p class="icon-header">{{ $t('free_delivery_over') }}</p>
        </div>
        <div class="icon-square">
          <div class="icon-cont-ticket">
            <img src="../assets/img/homeTicket.svg" style="height: 56px; width: 56px"/> -->
            <!-- <font-awesome-icon icon="ticket-alt" :style="{ color: 'black', fontSize: '50px'}" /> -->
          <!-- </div>
          <p class="icon-header">{{ $t('the_first_order') }}</p>
        </div>
        <div class="icon-square">
          <div class="icon-cont"> -->
            <!-- <font-awesome-icon icon="check-square" :style="{ color: 'black', fontSize: '50px'}" /> -->
            <!-- <img src="../assets/img/homeGuarantee.svg" style="height: 56px; width: 56px"/>
          </div>
          <p class="icon-header">{{ $t('quality_guarantee') }}</p>
        </div>
      </div>
    </div> -->

    <div class="category-buttons">
      <button
        type="button"
        class="category-scroll-arrow category-scroll-arrow-left"
        aria-label="Scroll categories left"
        @click.stop.prevent="scrollCategories(-1)">
        <font-awesome-icon icon="chevron-left"/>
      </button>
      <ul
        ref="categoryGroups"
        class="groups"
        :class="{'is-dragging': categoryDragging}"
        @mousedown="startCategoryDrag"
        @mousemove="dragCategories"
        @mouseup="stopCategoryDrag"
        @mouseleave="stopCategoryDrag"
        @dragstart.prevent>
        <li v-for="(item, index) in groups" :key="'category-buttons_'+index">
          <div class="group-button-container">
            <div class="image-placeholder" @click="onCategoryClick(item.ProductGroup_id)">
              <img class="button-image" :src="item.Image" alt="">
            </div>
            <p class="group-button-name">{{ curIsEnglish ? item.Name : item.Description }}</p>
          </div>
        </li>
      </ul>
      <button
        type="button"
        class="category-scroll-arrow category-scroll-arrow-right"
        aria-label="Scroll categories right"
        @click.stop.prevent="scrollCategories(1)">
        <font-awesome-icon icon="chevron-right"/>
      </button>
    </div>

    <!-- <div class="recommendation-section"> -->
      <!-- <div> -->
      <!-- <h2 class="rec-title">{{ $t('today_recommendation') }}</h2> -->
      <!-- </div> -->
      <!-- <div class="rec-container">
        <div v-for="(item,index) in customButtonCategories">
          <img v-if="$i18n.locale === 'en' && checkViewableLanguages(item.ViewableLanguages, 'en')" class="rec-img"
               :src="item.Image" alt="" :style="{cursor: 'pointer'}" @click="selectCustomCategory(item)">
          <img v-if="$i18n.locale === 'ch' && checkViewableLanguages(item.ViewableLanguages, 'ch')" class="rec-img"
               :src="item.Image" alt="" :style="{cursor: 'pointer'}" @click="selectCustomCategory(item)">
        </div>
      </div>
    </div> -->

    <!--category 2 products-->
    <div class="category-Bestsellers">
    <div v-for="(item,index) in showCustomNotBtnCategories" v-model="local=item.Products=='local'" data-index="index"
         :key="'showCustomNotBtnCategoriesKey_'+index">
      <div
        class="Bestsellers"
        v-if="(item.ListViewType==='middle-image' && checkViewableLanguages(item.ViewableLanguages, $i18n.locale) && item.IsMobile === false) || (item.ListViewType!=='middle-image' && item.Products.length>0 && checkViewableLanguages(item.ViewableLanguages, $i18n.locale))">
        <div v-if="item.ListViewType==='middle-image' && checkViewableLanguages(item.ViewableLanguages, $i18n.locale) && item.IsMobile === false" class="middle-image-container">
          <img :src="item.Image" @click="selectCustomCategory(item)"/>
        </div>
        <div class="page-width">
          <div
            v-if="item.ListViewType!=='middle-image' && item.Products.length>0"
            class="padding">
            <div class="text-start">
              <div class="titleTop">
                <h2>{{ curIsEnglish ? item.Name : item.Description }}</h2>
                <div class="titleRight" @click="selectCustomCategory(item)">{{$t('view_all')}} ></div>
              </div>
            </div>
            <homeSwiper :item="item" :index="index" :key="item.Name"></homeSwiper>
          </div>
        </div>
      </div>
    </div>
  </div>
    <!-- <div class="category2-list">
      <div class="filter-bar">
        <div v-for="(item,index) in this.categories" v-if="!item.IsButton && item.ListViewType!=='middle-image' ">
          <p @click="setNewCategory(item)"
             :class="selectedCategoryProducts.Name === item.Name ? 'selected' : '' "
             >{{ curIsEnglish ? capitalizeOnlyFirstLetter(item.Name) : item.Description }}</p>
        </div>
      </div>
      <ul>
        <li v-for="(p, index) in this.selectedCategoryProducts.Products" v-if="(showMore || index <  10)">
          <productCard 
            v-if='$i18n.locale=="en"'
            v-bind:img="p.Thumbnail"
            v-bind:link="p.link"
            v-bind:brand="p.Brand"
            v-bind:rating="p.Rating"
            v-bind:name="p.Name"
            v-bind:isPromotion="p.IsPromotion"
            v-bind:price="p.Price"
            v-bind:item="p"
            v-bind:quantity="p.Quantity"
            v-bind:key="index"
          ></productCard>
          <productCard 
            v-if='$i18n.locale=="ch"'
            v-bind:img="p.Thumbnail"
            v-bind:link="p.link"
            v-bind:brand="p.Brand"
            v-bind:rating="p.Rating"
            v-bind:name="p.Description"
            v-bind:isPromotion="p.IsPromotion"
            v-bind:price="p.Price"
            v-bind:item="p"
            v-bind:quantity="p.Quantity"
            v-bind:key="index"
          ></productCard>
        </li>
      </ul>
      <div class="show-more-container" v-if="!showMore && this.selectedCategoryProducts.Products.length > 10">
        <button class="show-more-button" @click="clickShowMore">{{ $t('showMore') }}</button>
      </div>
    </div> -->

    <pcRecommended :inCart="inCart"></pcRecommended>

    <!-- <div class="home-footer">
      <div class="icon-col" style="borderRight: 1px solid rgba(0, 0, 0, 0.25)">
        <div class="homeFooter-img">
          <img src="../assets/img/headset.svg" style="height: 50px; width: 50px"/>
        </div>
        <div class="homeFooter-text">
          <h2>{{ $t('customer_service') }}</h2>
          <p>{{ $t('call_chat_visit') }}</p>
        </div>
      </div>
      <div class="icon-col">
        <div class="homeFooter-img">
          <img src="../assets/img/truckHome.svg" style="height: 50px; width: 50px"/>
        </div>
        <div class="homeFooter-text">
          <h2>{{ $t('free_shipping') }}</h2>
          <p>{{ $t('get_shopafm_free') }}</p>
        </div>
      </div>
      <div class="icon-col" style="borderLeft: 1px solid rgba(0, 0, 0, 0.25)">
        <div class="homeFooter-img">
          <img src="../assets/img/onlinePayment.svg" style="height: 50px; width: 50px"/>
        </div>
        <div class="homeFooter-text">
          <h2>{{ $t('online_payment') }}</h2>
          <p>{{ $t('we_accept_all') }}</p>
        </div>
      </div>
    </div> -->
  </div>
  <mobileHome v-else/>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';
import {isUserAuthenticated, flyToElement} from "../store/modules/cart";
import productCard from "./productCard";
import productList from './productList';
import mobileHome from './mobile/mobileHome';
import pcRecommended from '../components/pc-recommended/pc-recommended';
import homeSwiper from '../components/home-swiper/home-swiper';
import $ from 'jquery';
import {locales, outOfStockSorts, showRecommendedData} from "../mixin";

const VERTICAL_NUM = 7; // 竖着排的数量

export default {
  name: "home",
  mixins: [showRecommendedData, locales, outOfStockSorts],
  components: {
    productCard,
    mobileHome,
    pcRecommended,
    homeSwiper
  },
  data() {
    return {
      showMore: false,
      categories: [],
      allCategoryProducts: [],
      selectedCategoryProducts: {
        Products: []
      },
      bannerSwiper: {
        slidesPerView: 1,
        spaceBetween: 0,
        observer: true,
        observeParents: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        simulateTouch: false,
        pagination: {
          el: '.home-banner-pagination',
          clickable: true,
        },
      },
      inCart: null,
      flushBbottom: {
        slidesPerView: 1,
      },
      homeImgLeft: true,
      categoryDragging: false,
      categoryDragMoved: false,
      categoryDragStartX: 0,
      categoryDragStartScrollLeft: 0,
    }
  },
  methods: {
    ...mapActions('cart', ['addProductToCart']),
    ...mapActions('products', ['fetchProductDetails']),
    ...mapMutations('products', ['updateActiveProduct']),
    ...mapMutations('checkout', ['setPricesForCheckout', 'saveTotalPrice', 'saveGrandTotal', 'clearPromoCode', 'clearCard']),
    capitalizeOnlyFirstLetter(string) {
      return string
      // let lowercase = string.toLowerCase();
      // return lowercase[0].toUpperCase() + lowercase.slice(1);
    },
    setNewCategory(category) {
      if (category.Name === 'All Categories') {
        this.$router.push('/collections')
      } else {
        this.selectedCategoryProducts = category;
        this.showMore = false;
      }
    },
    clickShowMore() {
      this.showMore = true;
    },
    homeImgCountChange() {
      this.homeImgLeft = !this.homeImgLeft;
      return true;
    },
    goToCollections() {
      this.$router.push('/collections')
    },
    goToCategory2(cat2) {
      this.$router.push(`/category2/${cat2.Name.toLowerCase()}`)
    },
    scrollCategories(direction) {
      const groups = this.$refs.categoryGroups;
      if (!groups) return;
      groups.scrollLeft += direction * Math.max(260, groups.clientWidth * 0.8);
    },
    startCategoryDrag(event) {
      if (event.button !== 0) return;
      const groups = this.$refs.categoryGroups;
      if (!groups) return;
      this.categoryDragging = true;
      this.categoryDragMoved = false;
      this.categoryDragStartX = event.clientX;
      this.categoryDragStartScrollLeft = groups.scrollLeft;
    },
    dragCategories(event) {
      if (!this.categoryDragging) return;
      const groups = this.$refs.categoryGroups;
      if (!groups) return;
      const distance = event.clientX - this.categoryDragStartX;
      if (Math.abs(distance) > 5) {
        this.categoryDragMoved = true;
      }
      groups.scrollLeft = this.categoryDragStartScrollLeft - distance;
      event.preventDefault();
    },
    stopCategoryDrag() {
      this.categoryDragging = false;
    },
    onCategoryClick(id) {
      if (this.categoryDragMoved) {
        this.categoryDragMoved = false;
        return;
      }
      this.navGo(id);
    },
    navGo(id) {
      const group = this.groups.filter(group => group.ProductGroup_id === id)[0];
      if (this.$router.currentRoute.params && this.$router.currentRoute.params.group) {
        if (this.$router.currentRoute.params.group.toLowerCase() !== group.Name.toLowerCase()) {
          // this.$router.push(`/collections/${group.Name.toLowerCase()}`)
          this.$router.push(`/collections`);
          setTimeout(() => {
            this.$root.selectNewGroup(group);
          }, 600);
        } else {
          // this.$root.fetchSelectedGroup(group.ProductGroup_id);
          this.$router.push(`/collections`);
          setTimeout(() => {
            this.$root.selectNewGroup(group);
          }, 600);
        }
      } else {
        // this.$router.push(`/collections/${group.Name.toLowerCase()}`)
        this.$router.push(`/collections`);
        setTimeout(() => {
          this.$root.selectNewGroup(group);
        }, 600);
      }
    },
    selectCustomCategory(cat2) {
      this.$router.push(`/collections`);
      setTimeout(() => {
        this.$root.selectNewCustomCategory(cat2);
      }, 600);
    },
    handleAddToCartSuccess(item) {
      this.$store.dispatch('cart/addCart', item)
        .then(() => {
          this.$store.dispatch('cart/getCart');
        });
    },
    handleAddToCartFail() {
      alert('Not enough product in stock');
    },
    findRightElement(item, p) {
      if (item.Product_id === p) {
        return
      }
    },
    setCategoryValues(newVal) {
      let oldCategories = JSON.parse(JSON.stringify(newVal));
      this.categories.splice(0, this.categories.length)
      this.selectedCategoryProducts = {
        Products: []
      }
      if (oldCategories.length < VERTICAL_NUM) {
        return
      }
      oldCategories.splice(0, VERTICAL_NUM)
      let arr = []
      oldCategories.forEach(item => {
        if (!item.IsButton && item.ListViewType !== 'middle-image') {
          arr.push(item)
        }
      })
      this.categories.push(...oldCategories)
      if (arr.length < 0) {
        return
      }
      this.categories.push({Name: 'All Categories', Description: '所有分類'})
      this.selectedCategoryProducts = arr[0]
    },
    addToCart: function (item, event) {
      if (isUserAuthenticated()) {
        this.addProductToCart({success: this.handleAddToCartSuccess, fail: this.handleAddToCartFail, item})
          .then(() => {
            flyToElement(event.target, $('.cart-link'));
          })
      } else {
        this.$store.dispatch('cart/addProductToLocalCart', item)
          .then(() => {
            this.$store.dispatch('cart/getCart');
            flyToElement(event.target, $('.cart-link'));
          })
      }
    },
    beforeRouteLeave(to, from, next) {
      if (isUserAuthenticated() && to.name === 'purchase') {
        this.$store.dispatch('cart/getCart')
          .then(() => {
            const cartItems = {};
            cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
            cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
            cartItems.ShippingMethod = "Delivery";
            cartItems.Tip = 0;
            cartItems.TipPercentage = 0;
            cartItems.TotalPrice = this.$store.state.cart.cartProductsList.TotalPrice;
            this.$store.dispatch('cart/saveAndAdjustCart', cartItems)
              .then(() => {
                this.saveGrandTotal(this.necessaryCartItems.GrandTotal);
                this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
              })
          })
      }
      this.clearPromoCode();
      this.clearCard();
      next();
    },
    checkViewableLanguages(data, lang) {
      for (let i = 0; i < data.split(',').length; i++) {
        let d = data.split(',')[i];
        if (d.toLowerCase()==='zh') { d = 'ch'}
        if (d.toLowerCase() === lang) {
          return true;
        }
      }
      return false;
    },
    onClickBillboard(url, type) {
      if (type === "URL") {
        window.location.href = url;
      } else if (type === "Category2") {
        this.$router.push(`/collections`);
        setTimeout(() => {
          this.$root.selectNewCustomCategory({Name: url});
        }, 600);
      } else if (type === "Group") {
        this.$router.push(`/collections`);
        setTimeout(() => {
          this.$root.selectNewGroup({Name: url});
        }, 600);
      } else if (type === "Category") {
        this.$router.push(`/collections`);
        setTimeout(() => {
          this.$root.selectNewCategory({Name: url});
        }, 600);
      } else {

      }
    },
    bannerSwiperMouseenter() {
      const bannerSwiperCom = this.$refs.bannerSwiperRef
      if (!bannerSwiperCom) {
        return
      }
      bannerSwiperCom.swiper.autoplay.stop()
    },
    bannerSwiperMouseleave() {
      const bannerSwiperCom = this.$refs.bannerSwiperRef
      if (!bannerSwiperCom) {
        return
      }
      bannerSwiperCom.swiper.autoplay.start()
    },
    fetchBillboardImages() {
      this.$store.dispatch('billboard/fetchBillboardImages');
    },
    fetchCustomCategories() {
      this.$store.dispatch('products/fetchCustomCategories', {
        company_id: this.companyId,
        warehouse_id: this.warehouseId
      });
    }
  },
  computed: {
    ...mapState({
      companyId: state => state.products.companyId,
      warehouseId: state => state.products.warehouseId,
      checkoutWithinRadius: state => state.navbar.checkoutWithinRadius,
      checkoutRadiusChecked: state => state.navbar.checkoutRadiusChecked,
      cartProductsList: state => state.cart.cartProductsList,
      token: state => state.auth.token,
      loggedIn: state => state.auth.loggedIn,
      itemCount: state => state.cart.itemCount,
      necessaryCartItems: state => state.cart.necessaryCartItems,
      cartClicked: state => state.cart.cartClicked,
      itemAdded: state => state.cart.itemAdded,
      groups: state => state.navbar.allGroups,
      customCategories: state => state.products.customCategories,
      billboardImages: state => state.billboard.billboardImages,
      windowWidth: state => state.navbar.windowWidth,
      isMobile() {
        return this.windowWidth < 800;
      },
    }),
    customButtonCategories() {
      return this.customCategories.filter(item => item.IsButton)
    },
    customNotBtnCategories() {
      const result = JSON.parse(JSON.stringify(this.customCategories.filter(item => !item.IsButton && this.getIsNotRecommended(item.Name))))
      return result.map(item => {
        return {
          ...item,
          Products: item.Products.reverse().sort(this.outOfStockToEnd)
        }
      })
    },
    showCustomNotBtnCategories() {
      return this.customNotBtnCategories.slice(0, VERTICAL_NUM)
    },
    filterBillboard({billboardImages, $i18n}) {
      const language = $i18n.locale
      return billboardImages.filter(image => {
        return image.Language.toLowerCase() === language;
      })
    }
  },
  activated() {
    if (this.isMobile) {
      return
    }
    const customCategories = this.customCategories
    if (!Array.isArray(customCategories) || !customCategories.length) {
      this.fetchCustomCategories();
    }
    const billboardImages = this.billboardImages
    if (!Array.isArray(billboardImages) || !billboardImages.length) {
      this.fetchBillboardImages();
    }
  },
  watch: {
    $route(to, from) {
      if (to.path === '/') {
        this.fetchBillboardImages();
        this.fetchCustomCategories();
      }
    },
    customNotBtnCategories: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setCategoryValues(newVal);
      }
    },
  },
}
</script>

<style lang="less">
@import "../assets/css/public.less";
@import "../assets/css/home.less";
@import "../assets/css/modal.less";

.home.page-container > .banner {
  padding: 0 50px;

  > .swiper-container {
    position: relative;
    width: 100%;
    overflow: hidden;
    border-radius: 30px;

    > .swiper-wrapper > .swiper-slide {
      flex-shrink: 0;
      width: 100%;
    }
  }
}

.home.page-container > .banner .home-banner-pagination {
  bottom: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;

  .swiper-pagination-bullet {
    width: 32px;
    height: 6px;
    margin: 0;
    background: #ddc983;
    border-radius: 999px;
    opacity: 0.25;
    transition: width 0.2s ease, opacity 0.2s ease;
  }

  .swiper-pagination-bullet-active {
    width: 48px;
    opacity: 1;
  }
}

</style>



// WEBPACK FOOTER //
// src/view/home.vue